import { Fields, ShortType } from 'models/PurchasesMetric'
import {
  AxiosAction,
  FailureAction,
  SuccessAction,
} from 'redux-axios-middleware'

export const GET_PURCHASES_METRICS = 'purchase_metrics/GET_METRICS'
export const GET_PURCHASES_METRICS_SUCCESS =
  'purchase_metrics/GET_METRICS_SUCCESS'
export const GET_PURCHASES_METRICS_FAIL = 'purchase_metrics/GET_METRICS_FAIL'

export type GetPurchasesMetricsAction = AxiosAction<
  typeof GET_PURCHASES_METRICS
>

export function getPurchasesMetrics(
  type: ShortType,
  params: {} = {}
): GetPurchasesMetricsAction {
  return {
    type: GET_PURCHASES_METRICS,
    payload: {
      client: 'default',
      request: {
        url: `purchases/${type}`,
        method: 'get',
        params,
      },
    },
  }
}

export type ResolvedAction =
  | FailureAction<typeof GET_PURCHASES_METRICS_FAIL>
  | SuccessAction<
      typeof GET_PURCHASES_METRICS_SUCCESS,
      { metric: Fields },
      GetPurchasesMetricsAction
    >
